import { Group } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';

import { ChatMessage } from '#core/components/chat/messages/ChatMessage';
import { type ToolComponentProps, useTool } from '#core/components/chat/tool';
import { useCogniteFunction } from '#core/hooks/fusion/useCogniteFunction';

import { FastSiFunction } from '#schema/function/FastSiFunction';

export function useFastSiFunctionTool() {
  const fn = useCogniteFunction(FastSiFunction);

  return useTool(
    'predict_scale_index',
    'Use this tool to predict the Scale Index (SI) using water chemistry and operational data. The model name is FastSI.',
    FastSiFunction.request.shape.ml_inputs,
    async ({ args, setContext }) => {
      setContext({ status: 'idle' });
      const data = await fn.call({ ml_inputs: args }, (status) => {
        setContext({ status });
      });
      return { message: data };
    },
    toolComponent,
  );
}

function toolComponent(_props: ToolComponentProps) {
  return (
    <ChatMessage role="assistant" kind="subtle">
      <Group gap="xs" align="center">
        <IconCircleCheck size={16} /> FastSI model executed successfully.
      </Group>
    </ChatMessage>
  );
}
